import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
    selector: 'ev-spinner',
    template: `<mat-spinner mode="indeterminate"></mat-spinner>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinner]
})
export class EvSpinnerComponent {
    
}
